import React from 'react';

/**
 * Modal component for selecting note templates
 * Displays available templates with descriptions and encounter type filters
 */
function TemplateSelector({ showTemplateSelector, setShowTemplateSelector, templates, handleTemplateSelect, loading = false }) {
  if (!showTemplateSelector) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setShowTemplateSelector(false)} onKeyDown={(e) => e.key === 'Escape' && setShowTemplateSelector(false)} role="dialog" aria-modal="true">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Select Note Template</h3>
            <button
              onClick={() => setShowTemplateSelector(false)}
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              ✕
            </button>
          </div>
          {loading ? (
            <div className="flex justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : templates.length === 0 ? (
            <p className="text-gray-500 dark:text-gray-400">No templates available. Please contact your administrator.</p>
          ) : (
            <div className="space-y-2">
              {templates.map((template) => (
                <button
                  key={template.id}
                  onClick={() => handleTemplateSelect(template)}
                  className="w-full text-left p-4 rounded-lg border border-gray-300 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors"
                >
                  <div className="font-medium text-gray-900 dark:text-white">{template.name}</div>
                  {template.description && (
                    <div className="text-sm text-gray-500 dark:text-gray-400 mt-1">{template.description}</div>
                  )}
                  {template.encounter_types && template.encounter_types.length > 0 && (
                    <div className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                      {template.encounter_types.join(', ')}
                    </div>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TemplateSelector;
